import script from "./currentExam.vue?vue&type=script&setup=true&lang=js"
export * from "./currentExam.vue?vue&type=script&setup=true&lang=js"

import "./currentExam.vue?vue&type=style&index=0&id=3856bf35&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3856bf35"]])

export default __exports__